export const getNaMotorInsuranceState = (state) => state?.naMotorInsurance;
